export const traceTour = (...args: unknown[]) => {
  if (__DEV__) {
    console.log('[onboarding]', ...args);
  }
};
